(function(){
    angular
        .module('appback')
        .directive('ngCoprologico057', coprologico057);

        coprologico057.$inject = ['ResultadosService','$timeout'];
        function coprologico057(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=coprologico057.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	/*if(!scope.item.resultado.extra){
		            		scope.item.resultado.extra = { resultado : { gusanos:[{}],huevos:[{}],quistes:[{}] }};
			            }*/
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                      }
	                    scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}


			        });
		        }
          }
      }
})();